import { decodeJWT } from '../utils/jwtUtils';
import { getCookie, removeCookie } from '../utils/cookiesUtils';
import { DateTime } from 'luxon';

let sessionCheckIntervalId: number | NodeJS.Timer | null = null;

function handleSessionExpired() {
    removeCookie('platform_token');

    if (sessionCheckIntervalId !== null) {
        clearInterval(sessionCheckIntervalId);
        sessionCheckIntervalId = null;
    }

    window.location.href = '/auth/login';
}

export function validateToken(): boolean {
    return true;

    // const platform_token = getCookie('platform_token');

    // if (platform_token) {
    //     try {
    //         const jwt_decoded = decodeJWT(platform_token);

    //         if (jwt_decoded) {
    //             const currentTimestamp = Math.floor(DateTime.now().toMillis() / 1000);
    //             const expirationTimestamp = jwt_decoded.exp || 0;

    //             if (expirationTimestamp > currentTimestamp) {
    //                 return true;
    //             } 
    //             else {
    //                 handleSessionExpired();
    //             }
    //         } 
    //         else {
    //             handleSessionExpired();
    //         }
    //     } 
    //     catch (error: any) {
    //         handleSessionExpired();
    //     }
    // } 
    // else {
    //     handleSessionExpired();
    // }

    // return false;
}

export function checkSessionExpiration(): number | NodeJS.Timer {
    if (sessionCheckIntervalId === null) {
        sessionCheckIntervalId = setInterval(() => {

            if (!validateToken()) {
                handleSessionExpired();
            }
        }, 300000);
    }
    return sessionCheckIntervalId;
}

checkSessionExpiration();
